import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { useIsDesktopDimension } from '@beef/ui-kit/hooks';
import { defineBlock } from "../../../../utils/blocks";
import { defaultsToPx } from "../../../../utils/catalogUtils";
import { CarouselComponent } from "../../../Carousel";
import { FttbBlocks } from "../../../../constants/blocks";
import styles from "./styles.pcss";
import { AlignedGridItem } from "./AlignedGridItem";
var cn = classNames.bind(styles);
var _AlignedGrid = function _AlignedGrid(_ref) {
  var children = _ref.children,
    _ref$levels = _ref.levels,
    levels = _ref$levels === void 0 ? 1 : _ref$levels,
    itemMaxSize = _ref.itemMaxSize,
    className = _ref.className,
    isCarouselEnabled = _ref.isCarouselEnabled;
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component', className),
    style: {
      gridTemplateRows: "repeat(".concat(levels, ", auto)"),
      gridAutoColumns: isDesktop ? itemMaxSize && "minmax(auto, ".concat(defaultsToPx(itemMaxSize), ")") : ''
    },
    "data-t-id": "common-AlignedGrid"
  }, /*#__PURE__*/React.createElement(CarouselComponent, {
    hasCarousel: isCarouselEnabled,
    isPaginate: true,
    itemsCount: children.length,
    spaceBetween: 24
  }, children));
};
_AlignedGrid.Item = AlignedGridItem;
_AlignedGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  levels: PropTypes.number,
  itemMaxSize: PropTypes.number,
  className: PropTypes.string,
  isCarouselEnabled: PropTypes.bool
} : {};
export var AlignedGrid = compose(defineBlock(FttbBlocks.TARIFFS))(_AlignedGrid);